import React from 'react'
import * as Yup from 'yup'

import { TtButton, TtCard } from '@23/ui-react'
import * as TtForms from '@23/react-forms'

import type { WidgetDTO } from '../../../../../../model/Widget'

const embedSchema = Yup.object({
  link: Yup.string()
    .trim()
    .transform((v) => (v === '' ? undefined : v))
    .required('Embed URL is required')
    .url('Invalid URL format'),
})

type FormValues = Yup.InferType<typeof embedSchema>

interface EmbedEditModeProps {
  widget: WidgetDTO
  onSave: (values: FormValues) => Promise<void>
  onCancel: () => void
}

const EmbedEditMode = ({ widget, onSave, onCancel }: EmbedEditModeProps) => (
  <TtCard
    className="personal-widget-embed personal-widget-embed--edit"
    hideLabel
  >
    <TtForms.Form<FormValues>
      className="personal-widget-embed-form"
      label="Edit embed url"
      initialValues={{
        link: widget.link ?? '',
      }}
      validationSchema={embedSchema}
      onSubmit={onSave}
      enableReinitialize
    >
      <TtForms.TextField<FormValues>
        name="link"
        label="Embed URL"
        placeholder="Embed URL"
      />
      <div className="personal-widget-embed-form-actions">
        <TtButton variant="outline" color="secondary" onClick={onCancel}>
          Cancel
        </TtButton>
        <TtForms.SubmitButton color="primary" disabled={false}>
          Save
        </TtForms.SubmitButton>
      </div>
    </TtForms.Form>
  </TtCard>
)

export { type FormValues as EmbedFormValues, EmbedEditMode }
